export default __webpack_public_path__ + "static/media/plain-sticker-o.fd3ad272.png";